import { getEnumValues } from './get-enum-values';
export enum RecruitingResponse{
	Yes='yes',
	No='no',
	Maybe='maybe',
}
export const RecruitingResponseValues = getEnumValues<RecruitingResponse>(RecruitingResponse);
